import PropTypes from 'prop-types';
import HighCharts from '../HighCharts';

import s from './BarChartBlock.module.css';

const BarChartBlock = ({
    title,
    displayLargeTitle,
    showTitleInToc,

    yAxisLabel,
    yAxisStackValues = false,
    yAxisMin,
    yAxisMax,
    yAxisTickInterval,

    decimalPlaces,

    propertySeriesQueries,
    aggregateSeriesQueries,

    xAxisLabel,
    xAxisLabelFormattting,
    xAxisCategorySortingType,
    xAxisCategoryOrdering,

    aggregateDataByCategory,

    dynamicProperty,
}) => {
    const plotOptions = {
        series: {
            stacking: yAxisStackValues,
            dataLabels: {
                // enabled: yAxisStackValues,
                enabled: false,
            },
        },
    };

    return (
        <div className={s.Root}>
            <HighCharts
                chartType="bar"
                title={title}
                showTitleInToc={showTitleInToc}
                displayLargeTitle={displayLargeTitle}
                yAxisLabel={yAxisLabel}
                yAxisMin={yAxisMin}
                yAxisMax={yAxisMax}
                yAxisTickInterval={yAxisTickInterval}
                decimalPlaces={decimalPlaces}
                xAxisLabel={xAxisLabel}
                xAxisLabelFormattting={xAxisLabelFormattting}
                xAxisCategorySortingType={xAxisCategorySortingType}
                xAxisCategoryOrdering={xAxisCategoryOrdering}
                aggregateDataByCategory={aggregateDataByCategory}
                propertySeriesQueries={propertySeriesQueries}
                aggregateSeriesQueries={aggregateSeriesQueries}
                dynamicProperty={dynamicProperty}
                plotOptions={plotOptions}
            />
        </div>
    );
};

BarChartBlock.propTypes = {
    title: PropTypes.string,
    displayLargeTitle: PropTypes.bool,
    showTitleInToc: PropTypes.bool,

    xAxisLabel: PropTypes.string,
    xAxisLabelFormattting: PropTypes.string,
    xAxisCategorySortingType: PropTypes.string,
    xAxisCategoryOrdering: PropTypes.string,

    yAxisLabel: PropTypes.string,
    yAxisMin: PropTypes.number,
    yAxisMax: PropTypes.number,
    yAxisTickInterval: PropTypes.number,
    yAxisStackValues: PropTypes.bool,

    decimalPlaces: PropTypes.number,

    aggregateDataByCategory: PropTypes.bool,

    propertySeriesQueries: PropTypes.array,
    aggregateSeriesQueries: PropTypes.array,

    dynamicProperty: PropTypes.string,
};

export default BarChartBlock;
